import ErrorParser from './errorParser';

const errParser = new ErrorParser();

export { errParser };
